import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import type { ExperienceImageTypes } from '@/types/gql.generated';
import { Image, type FlexProps } from '@/ui';
import { Container } from './Container';
import { getImageUrl } from './image.lib';

export type Props = FlexProps & {
  imageType: ExperienceImageTypes;
};

export const ImageRead = ({ imageType, ...containerProps }: Props) => {
  const { experience } = usePageExperienceContext();

  if (!experience) {
    return null;
  }

  const imageUrl = getImageUrl(experience, imageType);

  return (
    <Container {...containerProps}>
      {imageUrl && <Image borderRadius="8px" src={imageUrl} />}
    </Container>
  );
};
